export const BRANDS = ['kootstra', 'inselhuepfen', 'boatbiketours'] as const
export type Brand = typeof BRANDS[number]
export const DEFAULT_BRAND: Brand = 'boatbiketours' as const
